const ROLE_ORDERED = ["admin", "projectManager", "teamManager", "productor"];

const inMemoryJWT = () => {
    let inMemoryJWT = null;
    let inMemoryRole = null;
    let inMemoryRoleEditable = [];
    let inMemoryId = null;
    let isRefreshing = null;
    let logoutEventName = 'ra-logout';
    let refreshEndpoint = '/refresh-token';
    let setTokenEndpoint = null;
    let refreshTimeOutId;

    const setLogoutEventName = name => logoutEventName = name;
    const setRefreshTokenEndpoint = endpoint => refreshEndpoint = endpoint;

    const init = (refreshEndpoint: string, tokenEndpoint) => {
        setRefreshTokenEndpoint(refreshEndpoint);
        setTokenEndpoint = tokenEndpoint;
        return getRefreshedToken();
    }

    // This countdown feature is used to renew the JWT before it's no longer valid
    // in a way that is transparent to the user.
    const refreshToken = (delay) => {
        const timeout = delay - 5000;
        refreshTimeOutId = window.setTimeout(
            getRefreshedToken,
            timeout
        ); // Validity period of the token in seconds, minus 5 seconds
    };

    const abordRefreshToken = () => {
        if (refreshTimeOutId) {
            window.clearTimeout(refreshTimeOutId);
        }
    };

    // The method make a call to the refresh-token endpoint
    // If there is a valid cookie, the endpoint will set a fresh jwt in memory.
    const getRefreshedToken = () => {
        const request = new Request(refreshEndpoint, {
            method: 'GET',
            headers: new Headers({ 'Content-Type': 'application/json; charset=UTF-8' }),
            credentials: 'include',
            mode: 'cors'
        });

        isRefreshing = fetch(request)
            .then((response) => {
                if (response.status !== 200) {
                    ereaseToken();
                    return { token: null };
                }
                return response.json();
            })
            .then(({ token, expiresIn, user }) => {
                if (token) {
                    setToken(token, expiresIn, user);
                    return true;
                }
                ereaseToken();
                return false;
            });

        return isRefreshing;
    };

    const getId = () => inMemoryId;

    const getRole = () => inMemoryRole;

    const getRoleEditable = () => inMemoryRoleEditable;

    const getToken = () => inMemoryJWT;

    const setToken = (token, delay, user) => {
        inMemoryJWT = token;
        if (setTokenEndpoint) {
            setTokenEndpoint(token);
        }
        inMemoryId = user?.id;
        inMemoryRole = user?.role;
        const indexRole = ROLE_ORDERED.indexOf(inMemoryRole);
        inMemoryRoleEditable = (indexRole === -1) ? [] : ROLE_ORDERED.slice(indexRole + 1);
        refreshToken(delay);
        return true;
    };

    const ereaseToken = () => {
        inMemoryJWT = null;
        if (setTokenEndpoint) {
            setTokenEndpoint(null);
        }
        inMemoryId = null;
        inMemoryRole = null;
        inMemoryRoleEditable = [];
        abordRefreshToken();
        window.localStorage.setItem(logoutEventName, `${Date.now()}`);
        return true;
    }

    // This listener will allow to disconnect a session of ra started in another tab
    window.addEventListener('storage', (event) => {
        if (event.key === logoutEventName) {
            inMemoryJWT = null;
            if (setTokenEndpoint) {
                setTokenEndpoint(null);
            }
        }
    });

    return {
        init,
        getRefreshedToken,
        ereaseToken,
        getToken,
        setLogoutEventName,
        setRefreshTokenEndpoint,
        setToken,
        getRole,
        getRoleEditable,
        getId
    }
};

export default inMemoryJWT();